import type {
  HirerContract,
  HirerContractAction,
} from 'src/app/v1/state/types/hirerContract';

const defaultState: HirerContract = {
  adType: undefined,
  value: undefined,
  balance: undefined,
  type: undefined,
};

const RESET = 'session/hirerContract/RESET';
const UPDATE = 'session/hirerContract/UPDATE';

export const actionResetHirerContract = () => ({
  type: RESET,
});

export const actionUpdateHirerContract = (value: HirerContract) => ({
  type: UPDATE,
  value,
});

export default (
  state: HirerContract = defaultState,
  action: HirerContractAction,
) => {
  switch (action.type) {
    case RESET: {
      return defaultState;
    }
    case UPDATE: {
      return action.value;
    }
    default: {
      return state;
    }
  }
};

export const forTest = {
  defaultState,
  RESET,
  UPDATE,
};
